import axios from '@axios'

const emptyPagination = {
  page: 1,
  per_page: 10,
  total_pages: 0,
  total_objects: 0,
}

const state = () => ({
  taxInformations: {
    data: [],
    meta: {
      pagination: { ...emptyPagination },
    },
  },
  selectedTaxInformation: null,
  loading: false,
})

const getters = {
  taxInformations(state) {
    return state.taxInformations.data
  },
  pagination(state) {
    return state.taxInformations.meta?.pagination || { ...emptyPagination }
  },
  selectedTaxInformation(state) {
    return state.selectedTaxInformation
  },
  loading(state) {
    return state.loading
  },
}

const mutations = {
  SET_LOADING(state, payload) {
    state.loading = payload
  },
  SET_TAX_INFORMATIONS(state, payload) {
    state.taxInformations = payload
  },
  SET_SELECTED_TAX_INFORMATION(state, payload) {
    state.selectedTaxInformation = payload
  },
  CHANGE_PAGE(state, page) {
    if (!state.taxInformations.meta) state.taxInformations.meta = {}
    if (!state.taxInformations.meta.pagination) {
      state.taxInformations.meta.pagination = { ...emptyPagination }
    }
    state.taxInformations.meta.pagination.page = page
  },
}

const actions = {
  fetchTaxInformations(context, { customerId, pagination = { page: 1, per_page: 10 } }) {
    return new Promise((resolve, reject) => {
      if (!customerId) {
        const empty = {
          data: [],
          meta: { pagination: { ...emptyPagination } },
        }
        context.commit('SET_TAX_INFORMATIONS', empty)
        resolve(empty)
        return
      }

      context.commit('SET_LOADING', true)
      axios
        .get(`/v1/customers/${customerId}/tax_informations`, {
          params: {
            meta: {
              pagination,
            },
          },
        })
        .then(response => {
          context.commit('SET_TAX_INFORMATIONS', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response || error)
        })
        .finally(() => {
          context.commit('SET_LOADING', false)
        })
    })
  },
  createTaxInformation(context, { customerId, taxInformation }) {
    return new Promise((resolve, reject) => {
      context.commit('SET_LOADING', true)
      axios
        .post(`/v1/customers/${customerId}/tax_informations`, {
          tax_information: taxInformation,
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response || error)
        })
        .finally(() => {
          context.commit('SET_LOADING', false)
        })
    })
  },
  updateTaxInformation(context, {
    customerId,
    taxInformationId,
    taxInformation,
    usePut = false,
  }) {
    return new Promise((resolve, reject) => {
      context.commit('SET_LOADING', true)

      const method = usePut ? 'put' : 'patch'
      axios[method](`/v1/customers/${customerId}/tax_informations/${taxInformationId}`, {
        tax_information: taxInformation,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response || error)
        })
        .finally(() => {
          context.commit('SET_LOADING', false)
        })
    })
  },
  lookupPostalCode(context, { customerId, postalCode }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/v1/customers/${customerId}/tax_informations/postal_code_lookup`, {
          params: {
            postal_code: postalCode,
          },
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response || error)
        })
    })
  },
  deleteTaxInformation(context, { customerId, taxInformationId }) {
    return new Promise((resolve, reject) => {
      context.commit('SET_LOADING', true)
      axios
        .delete(`/v1/customers/${customerId}/tax_informations/${taxInformationId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response || error)
        })
        .finally(() => {
          context.commit('SET_LOADING', false)
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
